module.exports = __webpack_public_path__ + "static/media/leaderboards-mob-2x.ab35f772.png";